import { Text } from "@chakra-ui/react";
import { Row, Col } from "antd";
import { Control, UseFormSetValue } from "react-hook-form";
import Field from "ui/components/Input/Field";
import SelectContaCategoria from "ui/components/Input/SelectContaCategoria";
import InputMoney from "ui/components/Input/InputMoney";
import { FormAcordo, FormAcordoComposicao } from "core/features/acordo/typings";
import AddRemoveLineButton from "ui/components/Button/AddRemoveLineButton";

interface ComposicaoItemProps {
  control: Control<FormAcordo>;
  setValue: UseFormSetValue<FormAcordo>;
  composicoes: FormAcordoComposicao[];
  index: number;
  canEditComposicoes?: boolean;
}

function ComposicaoItem({
  control,
  index,
  composicoes,
  setValue,
  canEditComposicoes = true,
}: ComposicaoItemProps) {
  const onRemove = (index: number) => {
    const copy = [...composicoes];

    copy.splice(index, 1);

    setValue("composicoes", copy);
  };

  return (
    <Row gutter={16}>
      <Col sm={6}>
        <Field
          label={index === 0 ? "Categoria" : undefined}
          control={control}
          rules={{
            required: true,
          }}
          name={`composicoes.[${index}].categoriaFinanceiraId`}
          render={({ field, isInvalid }) => (
            <SelectContaCategoria
              disableNotClassifiableNodes
              isInvalid={isInvalid}
              value={field.value}
              disabled={!composicoes[index].added}
              idsToFilter={composicoes.map(
                (composicao) => composicao.categoriaFinanceiraId
              )}
              onChange={(v, item) => {
                field.onChange(v);
                setTimeout(() => {
                  if (composicoes[index]) {
                    composicoes[index].operacao = item.operacao;
                    setValue(`composicoes`, composicoes);
                  }
                }, 200);
              }}
            />
          )}
        />
      </Col>

      <Col sm={6}>
        <Field
          label={index === 0 ? "Alterar categoria" : undefined}
          control={control}
          name={`composicoes.[${index}].alterarParaCategoriaId`}
          render={({ field, isInvalid }) => (
            <SelectContaCategoria
              disableNotClassifiableNodes
              placeholder=""
              isInvalid={isInvalid}
              value={field.value}
              idsToFilter={composicoes
                .map((composicao) => composicao.alterarParaCategoriaId || "")
                .concat(composicoes[index].categoriaFinanceiraId)}
              onChange={(v, item) => {
                field.onChange(v);
                setTimeout(() => {
                  if (composicoes[index]) {
                    composicoes[index].operacao = item.operacao;
                  }
                  setValue(`composicoes`, composicoes);
                }, 200);
              }}
            />
          )}
        />
      </Col>

      <Col sm={6}>
        <Field
          label={index === 0 ? "Complemento" : undefined}
          control={control}
          name={`composicoes.[${index}].descricao`}
        />
      </Col>

      <Col sm={canEditComposicoes ? 4 : 6}>
        <Field
          label={index === 0 ? "Valor" : undefined}
          control={control}
          name={`composicoes.[${index}].valor`}
          rules={{
            required: true,
          }}
          render={({ field, isInvalid }) => (
            <InputMoney
              isInvalid={isInvalid}
              {...field}
              disabled={!canEditComposicoes}
            />
          )}
        />
        <Text color="red.500" textAlign="right" fontSize="12px">
          {composicoes[index].operacao === -1 ? "desconto" : null}
        </Text>
      </Col>

      {canEditComposicoes ? (
        <Col sm={2}>
          <AddRemoveLineButton
            showAdd={false}
            onRemove={() => onRemove(index)}
            containerProps={{
              pt: index > 0 ? 0 : 4,
            }}
          />
        </Col>
      ) : null}
    </Row>
  );
}

export default ComposicaoItem;
